import { For, type JSX } from 'solid-js';
import { type CodingModel, codingModelLines } from '../lib/coding-model';

// Presenter: which coding model a minted join command uses and where it came from
// (`lib/coding-model.ts`). `exported` = the command on screen exports it; otherwise
// the command prompts and the line says what to type there.

export function CodingModelLine(props: {
  readonly model: CodingModel;
  readonly exported: boolean;
}): JSX.Element {
  return (
    <div data-testid="coding-model">
      <For each={codingModelLines(props.model, props.exported)}>
        {(line) => <p class="field__desc">{line}</p>}
      </For>
    </div>
  );
}
